"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_common_get_url_params_1 = __importDefault(require("@gcloud-npm/utils.common.get-url-params"));
const tools_js_1 = require("./tools.js");
const WSElementType = {
    OK: "ok",
    ERROR: "error",
    ERROR_TIMEOUT: "error-timeout",
};
const MethodType = {
    POST: "POST",
    GET: "GET",
    PUT: "PUT",
    HEAD: "HEAD",
};
const SONDASTATUS = {
    STARTED: "started",
    LOADED: "loaded",
};
const HTTPSTATUS = {
    ERROR: '500',
    OK: '200'
};
const STATUSTEXT = {
    KO: 'ko',
    OK: 'ok',
};
const ERROR_COLOR = "\x1b[31m%s\x1b[0m"; // red
const WARNING_COLOR = "\x1b[33m%s\x1b[0m"; // yellow
const INFO_COLOR = "\x1b[36m%s\x1b[0m"; // cyan
const SUCCESS_COLOR = "\x1b[32m%s\x1b[0m"; // green
const DefaultHeaders = {
    timeout: 60000,
};
const isFrontApp = typeof window !== "undefined";
const getProperColorByStatus = (statusCode) => {
    switch (statusCode) {
        case 200:
            return SUCCESS_COLOR;
        case 300:
            return WARNING_COLOR;
        case 500:
            return ERROR_COLOR;
        default:
            return INFO_COLOR;
    }
};
const pipeLog = ({ endpoint, data, headers, status, level = 'info' }) => {
    const color = getProperColorByStatus(status);
    if (typeof window === "undefined" && (process.env.CLOUD_RUN_RUNNING !== 'true' || level === 'error')) {
        console.log(color, `Endpoint: ${endpoint}`);
        if (data) {
            console.log(color, JSON.stringify(data).substring(0, 100));
        }
        console.log(INFO_COLOR, JSON.stringify(headers));
    }
};
const stopProcessDependsOnBuildAndEnv = (build, endpoint, data, headers) => {
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (currentEnv === "prod" && build) {
        // para el log del pipeline
        if (typeof window === "undefined") {
            pipeLog({
                endpoint,
                data,
                headers,
                status: 500,
                level: 'info',
            });
            process.exit(1);
        }
    }
};
const sendSondas = (request, status, wsStatus = null, httpStatus = null, statusText = null) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        if (isFrontApp && window.dynatrace) {
            const attributesDynatrace = {
                "event.provider": 'Desarrollo NCOL',
                "event.type": `${process.env.NEXT_PUBLIC_PROJECT_ID || ''}`,
                "event.category": `${process.env.NEXT_PUBLIC_PROJECT_ID || ''}`,
                Cookie: (_a = request.payload) === null || _a === void 0 ? void 0 : _a.ga,
                idPeticion: request.sonda.getUniqueId().replace(/idPeticion=/g, '') || '',
                Referer: request.href,
                RequestPath: request.endpoint,
                status: status,
                httpStatus: httpStatus,
                CodErrorNegocio: statusText,
            };
            try {
                window.dynatrace.sendBizEvent(attributesDynatrace['event.type'], attributesDynatrace);
            }
            catch (e) {
                console.log(e);
            }
        }
        const timeSend = new Date(Date.now()).toISOString();
        if (status === 'started') {
            if (request.sonda && request.sonda.startWS) {
                request.sonda.startWS({
                    time: timeSend,
                    info: {
                        href: request.href,
                        endpoint: request.endpoint,
                        type: request.method,
                        payload: request.payload,
                    },
                });
            }
        }
        else {
            if (request.sonda && request.sonda.endWS) {
                request.sonda.endWS({
                    status: wsStatus,
                    info: {
                        status: httpStatus,
                        statusText,
                        endpoint: request.endpoint,
                        type: request.method,
                        payload: request.payload,
                        href: request.href,
                    },
                    time: timeSend,
                });
            }
        }
    }
    catch (e) {
    }
});
class Request {
    constructor({ method = MethodType.GET, endpoint, headers, dataStringify = true, data, dynaData = null, sonda, redirectAsReject = false, throwsError = false, beacon = false, build = false, onError, onTimeout, onSuccess, onRedirect, onFetching, log = false, responseType = 'json', }) {
        /* MAIN */
        this.makeRequest = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                // configurar peticion y ejecutarla( TODO config de errores falta)
                const { headers: ownHeaders, timeout, withCredentials, } = this.extractFromHeaders2RootProperties();
                if (!this.beacon) {
                    if (this.sonda) {
                        if (this.onFetching) {
                            this.onFetching();
                        }
                    }
                    sendSondas(this, SONDASTATUS.STARTED);
                    let wsStatus = null, httpStatus = null, statusText = null, statusCode = null;
                    fetch(this.endpoint, {
                        method: this.method,
                        headers: ownHeaders,
                        timeout,
                        body: this.data ? JSON.stringify(this.data) : null,
                        credentials: withCredentials ? "include" : "same-origin",
                    })
                        .then((response) => __awaiter(this, void 0, void 0, function* () {
                        httpStatus = response.status;
                        // text (con formato json) =>
                        // text html (302)
                        // json => json
                        if (!response.ok) {
                            let errorjson = null;
                            try {
                                errorjson = yield response.json();
                            }
                            catch (e) { }
                            try {
                                errorjson = yield response.text();
                            }
                            catch (e) { }
                            if (!errorjson) {
                                errorjson = {};
                            }
                            wsStatus = WSElementType.ERROR;
                            statusText = STATUSTEXT.KO;
                            // getErrorInfo
                            if (typeof errorjson === 'object') {
                                const { errorCode, errorDetails } = (0, tools_js_1.getErrorInfo)(errorjson);
                                statusCode = errorCode;
                                statusText = errorDetails;
                            }
                            else if (errorjson.indexOf("timeout") !== -1) {
                                statusCode = WSElementType.ERROR_TIMEOUT;
                                statusText = `Timeout Error${this.headers && this.headers.timeout ? `: ${this.headers.timeout}ms` : ""}`;
                            }
                        }
                        else {
                            wsStatus = WSElementType.OK;
                            statusText = response.statusText;
                        }
                        const url = new URL(response.url);
                        let data = '';
                        if (wsStatus === WSElementType.OK) {
                            try {
                                data = yield response[this.responseType]();
                            }
                            catch (e) {
                                data = response;
                            }
                        }
                        else {
                            data = statusText;
                        }
                        return this.responseHandler({
                            data,
                            status: response.status,
                            host: url.host
                        }, resolve, reject);
                    }))
                        .catch((error) => {
                        wsStatus = WSElementType.ERROR;
                        httpStatus = HTTPSTATUS.ERROR;
                        statusText = STATUSTEXT.KO;
                        if (this.log) {
                            stopProcessDependsOnBuildAndEnv(this.build, this.endpoint, this.data, this.headers);
                        }
                        this.errorHandler(error, reject);
                    }).finally(() => {
                        sendSondas(this, SONDASTATUS.LOADED, wsStatus, httpStatus, statusText);
                    });
                }
                else if (navigator && navigator.sendBeacon) {
                    try {
                        navigator.sendBeacon(this.endpoint, JSON.stringify(this.data));
                        const isShowSondaEnable = isFrontApp && window.location.search.indexOf("showSonda") > -1;
                        if (isShowSondaEnable) {
                            const { ctzId, cdEventName, cdTimeStamp, cdEventType } = this.data;
                            if (this.log) {
                                console.table([ctzId, cdEventName, cdTimeStamp, cdEventType], ["idPetición", "Servicio", "TimeStamp", "Tipo"]);
                            }
                        }
                    }
                    catch (e) {
                        console.error(`No se pudo ejecutar sondado`, e);
                    }
                }
            }));
        });
        this.method = method;
        this.endpoint = endpoint;
        this.data = data;
        this.dynaData = dynaData;
        this.sonda = sonda;
        this.headers = Object.assign(Object.assign({}, DefaultHeaders), headers);
        this.dataStringify = dataStringify;
        this.redirectAsReject = redirectAsReject;
        this.onError = onError;
        this.build = build;
        this.onTimeout = onTimeout;
        this.onSuccess = onSuccess;
        this.onRedirect = onRedirect;
        this.onFetching = onFetching;
        this.throwsError = throwsError;
        this.beacon = beacon;
        this.attributesDynatrace = null;
        this.log = log;
        this.responseType = responseType;
        // preparamos el payload
        this.payload = (0, utils_common_get_url_params_1.default)({ currentUrl: this.endpoint });
        // compruebo si hay dyna en pagina
        if (typeof window !== "undefined") {
            // WINDOW LOCATION
            this.href = "";
            if (window && window.location && window.location.href) {
                this.href = window.location.href;
            }
            if (!endpoint) {
                if (this.log) {
                    console.error("[Request]: endpoint prop can not be undefined");
                }
            }
        }
    }
    responseHandler(response, resolve, reject) {
        // Analizamos la reponse
        let currentStatus = response && response.status;
        if (response &&
            response.request &&
            response.request.host &&
            response.request.host === "accounts.google.com") {
            currentStatus = 300;
        }
        if (response && response.data && response.data.redirected) {
            currentStatus = 302;
        }
        if (currentStatus >= 200 && currentStatus < 300) {
            if (response) {
                if (this.onSuccess) {
                    let onSuccessData = null;
                    try {
                        onSuccessData = this.onSuccess({ data: response.data });
                    }
                    catch (e) {
                        pipeLog({
                            endpoint: this.endpoint,
                            data: e,
                            headers: this.headers,
                            status: currentStatus,
                            level: 'error',
                        });
                    }
                    finally {
                        resolve(onSuccessData || response.data);
                    }
                }
                else {
                    resolve(response.data);
                }
            }
        }
        else if (currentStatus >= 300 && currentStatus < 400) {
            if (this.redirectAsReject) {
                reject(response);
            }
            else {
                if (this.onRedirect) {
                    this.onRedirect((response === null || response === void 0 ? void 0 : response.data) || {});
                }
            }
        }
        else if (currentStatus >= 400 && currentStatus < 600) {
            reject(response.data);
        }
        pipeLog({
            endpoint: this.endpoint,
            data: this.data,
            headers: this.headers,
            status: currentStatus,
            level: 'info',
        });
    }
    errorHandler(error, reject) {
        let obj2Reject = {};
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            obj2Reject = error.response;
        }
        else if (error.request) {
            obj2Reject = error.request;
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
        }
        else {
            obj2Reject = error;
            // Something happened in setting up the request that triggered an Error
        }
        if (this.onError) {
            let onErrorData = null;
            try {
                onErrorData = this.onError(obj2Reject);
            }
            catch (e) {
                pipeLog({
                    endpoint: this.endpoint,
                    data: e,
                    headers: this.headers,
                    status: 500,
                    level: 'error',
                });
            }
            finally {
                obj2Reject = (onErrorData || obj2Reject);
            }
        }
        pipeLog({
            endpoint: this.endpoint,
            data: this.data,
            headers: this.headers,
            status: 500,
            level: 'error',
        });
        reject(obj2Reject);
    }
    extractFromHeaders2RootProperties() {
        const { headers } = this;
        const res = {
            timeout: null,
            withCredentials: null,
            headers: Object.assign({}, headers),
        };
        if (res.headers.timeout) {
            res.timeout = headers.timeout;
            delete res.headers.timeout;
        }
        if (res.headers.withCredentials) {
            res.withCredentials = headers.withCredentials;
            delete res.headers.withCredentials;
        }
        return res;
    }
}
exports.default = Request;
//# sourceMappingURL=index.js.map